import { JSX, memo, useCallback } from 'react';
// mui
import { debounce, SelectChangeEvent } from '@mui/material';
// components
import SelectController, { ISelectController } from 'controllers/select-controller';
// api
// styles
import { styles } from './styles';
import { ICostCodeSelect } from './types';

const CostCodeSelect = ({
  isCostCodesFetching,
  options,
  name,
  selectedOptionName,
  setCostCodesParams,
  resetCostCodesParams,
  setSelectedOptionName,
  onIntersection,
  ...props
}: ICostCodeSelect) => {
  const onSearchChange = useCallback<(value?: string) => void>(
    debounce((searchValue) => {
      setCostCodesParams((prev) => ({
        ...prev,
        cursor: undefined,
        search: searchValue ? searchValue : undefined,
      }));
    }, 300),
    []
  );

  const getSelectedOptionLabel = useCallback(
    (
      selectOptions: ISelectController['options'],
      selectedValue?: ISelectController['options'][number] | number,
      title?: string
    ): string | null => {
      return typeof selectedValue === 'number'
        ? selectOptions?.find(({ value }) => value === selectedValue).label
        : !selectedValue && title
          ? title
          : null;
    },
    []
  );

  const renderSelectValue = useCallback(
    (selectedValue?: ISelectController['options'][number] | number): JSX.Element => {
      return (
        <p>
          {getSelectedOptionLabel(options, selectedValue, selectedOptionName) ?? 'Select Cost Code'}
        </p>
      );
    },
    [getSelectedOptionLabel, options, selectedOptionName]
  );

  const onChange = useCallback(
    (e: SelectChangeEvent<number>) => {
      const foundedOption = options.find(({ value }) => value === e.target.value);

      if (foundedOption) {
        setSelectedOptionName(foundedOption.label, foundedOption.value);
      }
    },
    [setSelectedOptionName, options]
  );

  return (
    <SelectController
      fullWidth
      isSelect
      withError
      name={name}
      paperStyles={styles.paperStyles}
      options={options}
      withDataFetching={true}
      isFetching={isCostCodesFetching}
      onIntersection={onIntersection}
      onSearchChange={onSearchChange}
      onClose={resetCostCodesParams}
      renderValue={renderSelectValue}
      onChange={onChange}
      {...props}
    />
  );
};

export default memo(CostCodeSelect);
